export const SET_LOGS = 'SET_LOGS';
export const SET_PAGINATION = 'SET_PAGINATION';
export const SET_LOG_FILES = 'SET_LOG_FILES';
export const SET_LOG_FILES_PAGINATION = 'SET_LOG_FILES_PAGINATION';
export const SET_LOG_COLUMN = 'SET_LOG_COLUMN';
export const SET_LIMIT = 'SET_LIMIT';
export const SET_LOG_FILES_LIMIT = 'SET_LOG_FILES_LIMIT';
